import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let FoundryVTTInstructions = class FoundryVTTInstructions extends Vue {
};
FoundryVTTInstructions = __decorate([
    Component
], FoundryVTTInstructions);
export default FoundryVTTInstructions;
